export default __webpack_public_path__ + "static/media/icon-open-menu.63b14215.svg";